var Cards = require('../../lib/cards.js');
var OpenRounds = require('../../lib/open-rounds.js');

module.exports = function() {
    new OpenRounds();

    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'masonry');

    /**
     * Filtertron
     */
    $('.filtertron').filtertron('entries', {
        expander: '#filtertronExpander',
        cards: cards
    });
};
